import React, { useContext, useEffect, useState } from 'react'
import Select from "react-select"
import TableBS from './TableBS'
import GridBS from './GridBS'
import { FilterBSData, GetAllMemberIdArray, GetAllMemberIdArrayWithSession, GetBSList, GetKlaListForSearchFilter, GetMemberListForSearchFilter, GetMemberListForSearchFilterWithSession, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla } from '../../Services/allApi'
import Logo_path from '../../Components/Logo_path'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addcontext } from '../../ContextShare/ContextShare'
import { Icon } from '@iconify/react';
import language from '../../language.json'
import usePersistedState from '../../hooks/usePersistedState'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
function BudgetSpeech() {
    // const {paginationForGovernerAddress,setPaginationForGovernerAddress}=useContext(addcontext)
    const { paginationStartIndex, setPaginationStartIndex } = useContext(addcontext)
    const { paginationEndIndex, setPaginationEndIndex } = useContext(addcontext)
    const { archivesPaginationTotal, setarchivesPaginationTotal } = useContext(addcontext)
    const { archivesPaginationEnd, setarchivesPaginationEnd } = useContext(addcontext)
    const { archivesPaginationStart, setarchivesPaginationStart } = useContext(addcontext)
    const [errorMessage, setErrorMessage] = useState()
    const [isGridView, setIsGridView] = useState(false)
    const [getBsListData, setGetBsListData] = useState([])
    const [startDate, setStartDate] = usePersistedState('filters.budgetSpeech.startDate', null);
    const [endDate, setEndDate] = usePersistedState('filters.budgetSpeech.endDate', null);
    const [klaList, setKlaList] = useState([]);
    const [sessionList, setSessionList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [governerList, setgovernerList] = useState([]);
    const [videoCount, setVideoCount] = useState()
    const [isFiltered, setisFiltered] = usePersistedState('filters.budgetSpeech.isFiltered', false)

    // Function to toggle between table and grid view
    const toggleView = () => {
        setIsGridView(!isGridView);
    };
    const [selectedOptionKla, setSelectedOptionKla] = usePersistedState('filters.budgetSpeech.selectedOptionKla', null)
    const handlechange = (selectedOptionKla) => {
        setSelectedOptionKla(selectedOptionKla)
        setisFiltered(true)
    }
    const [selectedOptionsession, setSelectedOptionsession] = usePersistedState('filters.budgetSpeech.selectedOptionsession', null)
    const handlechangesession = (selectedOptionsession) => {
        setSelectedOptionsession(selectedOptionsession)
        setisFiltered(true)
    }
    const [selectedOptionsubject, setSelectedOptionsubject] = usePersistedState('filters.budgetSpeech.selectedOptionsubject', null)
    const handlechangesubject = (selectedOptionsubject) => {
        setSelectedOptionsubject(selectedOptionsubject)
        setisFiltered(true)
    }
    const [selectedOptiongoverner, setSelectedOptiongoverner] = usePersistedState('filters.budgetSpeech.selectedOptiongoverner', null)
    const handlechangegoverner = (selectedOptiongoverner) => {
        setSelectedOptiongoverner(selectedOptiongoverner)
        setisFiltered(true)
    }
    const { langChanged, setlangChanged } = useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en')
    }, [currentLanguage, langChanged])

    // filter logic starts-----------------------------------------------------------------

    // Fetch KLA List
    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaList(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApi();
    }, []);

    const klaoptions = klaList.map((item) => ({
        value: item.kla_id,
        label: `${language.kla[currentLanguage]}${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApi = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionList(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApi();
    }, [selectedOptionKla]);

    const sessionoptions = sessionList.map((item) => ({
        value: item.session_id,
        label: `${language.Session[currentLanguage]}${item.session_no}`,
    }));

    // Fetch Member List
    const MemberListCallApi = async () => {
        try {
            // const resultMember =selectedOptionsession? await GetMemberListForSearchFilterWithSession({session_id:selectedOptionsession?.value}):await GetMemberListForSearchFilter();
            const resultMember = selectedOptionsession ? await GetAllMemberIdArrayWithSession({ session_id: selectedOptionsession?.value }) : await GetAllMemberIdArray();
            setgovernerList(resultMember?.data || []);
            // console.log(resultMember.data);
        } catch (error) {
            console.error("Error fetching Member list for filter:", error);
        }
    };

    useEffect(() => {
        MemberListCallApi();
    }, [selectedOptionsession]);

    const governeroptions = governerList.map((item) => ({
        value: item.id,
        label: currentLanguage == 'en' ? item.member : item?.malayalam_member_name
    }));

    // filter logic ends-----------------------------------------------------------------

    // get budget speech
    const budgetSpeechData = async () => {
        try {
            const result = await GetBSList(paginationStartIndex,paginationEndIndex);
            console.log(result);
            console.log(result?.data?.data);
            setGetBsListData(result?.data?.data)
            setVideoCount(result?.data?.count)

        } catch (error) {
            console.error("Error fetching governor's address data:", error);
        }
    }
    useEffect(() => {
        if(!isFiltered){
        budgetSpeechData();
        }
    }, [paginationStartIndex, paginationEndIndex]);
    
    const handleStartDate=(StDate)=>{
        setStartDate(StDate)
        setisFiltered(true)
    }
    const handleEndDate=(EnDate)=>{
        setEndDate(EnDate)
        setisFiltered(true)
    }
    
    // filter table
    const Filter = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        const member_id = selectedOptiongoverner?.value;
        const start_date = startDate
        const end_date = endDate
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        if (member_id) obj.member_id = member_id;
        if (startDate) obj.start_date = start_date
        if (end_date) obj.end_date = end_date
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const result = await FilterBSData(obj,paginationStartIndex,paginationEndIndex);
            setGetBsListData(result?.data?.data || []);
            setVideoCount(result?.data?.count)

            setTimeout(() => {
                setErrorMessage(result?.response?.data?.message || null)
            }, 1000)
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession || selectedOptiongoverner || startDate || endDate)
            if(isFiltered){
            Filter();
            }
    }, [selectedOptionKla, selectedOptionsession, selectedOptiongoverner, startDate, endDate,paginationStartIndex, paginationEndIndex]);

    // reset filter 
    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setSelectedOptiongoverner(null)
        // setSelectedOptionEvent(null)
        // setSelectedOptionsubject(null)
        setStartDate('')
        setEndDate('')
        budgetSpeechData()
        setErrorMessage()
        setisFiltered(false)

    }
    return (
        <>
            {/* <div className='w-full flex justify-center'>
                <div className='md:w-11/12 w-full'>
                    <Logo_path Directory={'Budget speech'} AdminOrHome={'Home'} />
                </div>

            </div> */}
            <div className='flex flex-col items-center' style={{ height: '100%', width: '100%', fontFamily: 'Ropa sans' }}>
                <div className='md:w-11/12 w-full md:mb-10 mb-4'>
                    <div><Logo_path AdminOrHome={'Home'} Directory={'Budget speech'} /></div>
                </div>
            </div>

            <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>

                <div className='w-10/12 flex flex-col'>

                    <div className='text-center'><h2 className='text-xl mt-0'>{language.navbar.budget_speech[currentLanguage]}</h2></div>
                    <div className='flex flex-row justify-between'>

                        <div>
                        <div className={`text-left text-sm ${currentLanguage === 'en' ? 'text-sm ':'text-[9px]'}`}>
                        {getBsListData?.length > 0 ? <h4 className='mt-5'>{language.total_results[currentLanguage]} : {videoCount}</h4>
                                    :
                                    <>
                                        {errorMessage ?
                                            ''
                                            :
                                            <Skeleton width={100} />}
                                    </>
                                }
                            </div>
                            <div className={`text-left text-sm ${currentLanguage === 'en' ? 'text-sm ':'text-[9px]'}`}>
                                {getBsListData?.length > 0 ? <h4 className='mt-3'>{language.showing_results[currentLanguage]}  {paginationStartIndex}-{videoCount>=10?paginationEndIndex:videoCount} {language.results[currentLanguage]} </h4>
                                    :
                                    <>
                                        {errorMessage ?
                                            ''
                                            :
                                            <Skeleton width={110} />}
                                    </>
                                }
                            </div>                        </div>

                            <div className={`${currentLanguage != 'en' &&'text-xs'} `}>
                            {!isGridView ? <button className='p-2 bg-blue-500 rounded hover:bg-primary mt-5 text-white transition duration-200 ease-in-out' onClick={toggleView}>
                                <i class="fa-regular fa-image me-2"></i>{language.grid_view[currentLanguage]}</button>
                                :
                                <button className='p-2 bg-blue-500 rounded hover:bg-primary mt-5 text-white transform transition duration-200 ease-in-out' onClick={toggleView}>
                                    <i class="fa-solid fa-table me-2"></i>{language.table_view[currentLanguage]}</button>
                            }
                        </div>
                    </div>

                    {(getBsListData?.length > 0 || errorMessage) ? <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap mt-5'>

                        <div className='flex flex-col  text-blue-400'>
                            {/* <button className=''>Select KLA</button>
        <i className="fa-solid fa-chevron-down ms-2 text-sm"></i> */}
                            <div style={{ visibility: 'hidden' }}>end date</div>

                            <Select
                                placeholder={language.kla[currentLanguage]}
                                className='w-full min-w-40 h-9'
                                options={klaoptions}
                                value={selectedOptionKla}
                                onChange={handlechange} />
                        </div>

                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>

                            <Select
                                placeholder={language.Session[currentLanguage]}
                                className='w-full min-w-40 h-9'
                                options={sessionoptions}
                                value={selectedOptionsession}
                                onChange={handlechangesession} />
                        </div>

                        {/* <div className='flex flex-row '>
                            <Select
                                placeholder='Select Subject'
                                className='w-full text-blue-400'
                                options={subjectoptions}
                                value={selectedOptionsubject}
                                onChange={handlechangesubject} />
                        </div> */}

                        <div className='flex flex-col text-blue-400'>
                            <div style={{ visibility: 'hidden' }}>end date</div>

                            <Select
                                placeholder={language.Minister[currentLanguage]}
                                className='w-full min-w-40 h-9'
                                options={governeroptions}
                                value={selectedOptiongoverner}
                                onChange={handlechangegoverner} />
                        </div>

                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                            <div >{language.Start_date[currentLanguage]}</div>

                            <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                    type='date'
                                    value={startDate}
                                    // onChange={(date) => setStartDate(date.target.value)}
                                    // value={startDate}
                                    // onChange={(date) => setStartDate(date.target.value)}
                                    onChange={(date)=>handleStartDate(date.target.value)}
                                    placeholderText="Start date"
                                    className='rounded w-full h-9 p-2 min-w-40'
                                />
                            </div>
                        </div>

                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                            <div>{language.End_date[currentLanguage]}</div>

                            <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                    type='date'
                                    // value={endDate}
                                    // onChange={(date) => setEndDate(date.target.value)}
                                    onChange={(date)=>handleEndDate(date.target.value)}
                                    placeholderText="End date"
                                    className='rounded w-full h-9 min-w-40'
                                />
                            </div>
                        </div>

                        {(selectedOptionKla || selectedOptionsession || selectedOptiongoverner || startDate || endDate) && (
                            <div className='flex flex-col '>
                                <div style={{ visibility: 'hidden' }}>end date</div>

                                <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                    <span>{language.Clear_Filter[currentLanguage]}</span>
                                    <Icon icon="bx:reset" />
                                </button>

                            </div>)}

                    </div>
                        :
                        <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap md:mt-8 md:mb-5'>

                            <div className='md:w-40 w-0'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>
                            <div className='md:w-40 w-full'>
                                <Skeleton height={30} />
                            </div>

                            <div className='md:w-40 w-0'>
                                <Skeleton height={30} />
                            </div>

                        </div>
                    }

                    {/* {!isGridView?<TableBS getBsListData={getBsListData}/>:<GridBS getBsListData={getBsListData}/>} */}

                    <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap mt-5'>
                        {/* Render either TableBS or GridBS based on isGridView state */}
                        <div className={`md:w-12/12 w-full transition-opacity duration-500 ease-in-out ${isGridView ? 'opacity-0 max-h-0 overflow-hidden' : 'opacity-100 max-h-full'}`}>
                            <TableBS getBsListData={getBsListData} erm={errorMessage ?? null} handleResetFilter={handleResetFilter} count={videoCount} />
                        </div>
                        <div className={`md:w-12/12 w-full transition-opacity duration-500 ease-in-out ${isGridView ? 'opacity-100 max-h-full' : 'opacity-0 max-h-0 overflow-hidden'}`}>
                            <GridBS getBsListData={getBsListData} />
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default BudgetSpeech